import axios from "axios";
import _ from "lodash";

const initialState = {
  user: null,
  accounts: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "ADD_USER": {
      const { user } = action;
      axios.defaults.headers.common.Authorization = user.api_key;

      return {
        ...state,
        user: user,
        accounts: [...state.accounts, user]
      };
    }
    case "UPDATE_USER": {
      const accounts = state.accounts.map(item => {
        if (item.id === action.user.id) {
          // action.user
          return {
            ...item,
            ...action.user
          };
        }
        return item;
      });
      const user = accounts.find(item => item.id === action.user.id) || null;

      return {
        ...state,
        user: user,
        accounts
      };
    }
    case "SWITCH_USER": {
      let account = state.accounts.find(item => item.id === action.user.id);

      axios.defaults.headers.common.Authorization = account.api_key;

      return {
        ...state,
        user: account
      };
    }
    case "LOGOUT": {
      const accounts = state.accounts.filter(
        item => action.user.id !== item.id
      );
      let user = null;
      delete axios.defaults.headers.common.Authorization;
      axios.defaults.headers.common.Authorization =
        process.env.REACT_APP_API_SECRETE;
      if (accounts.length > 0) {
        user = _.head(accounts) || null;
      }

      if (user) {
        axios.defaults.headers.common.Authorization = user.api_key;
      }

      return {
        ...state,
        accounts,
        user: user
      };
    }
    default:
      return state;
  }
}
